<template>
    <layout :title="$attrs.title" :required="$attrs.required">
        <div class="custom-select-container flex flex-row flex-row-aic">
            <div class="left" @click="() => show = !show">
                <div v-if="selectVal" class="value">{{ selectVal }}</div>
                <div v-else class="default">请选择</div>
            </div>
            <div class="right">
                <van-icon v-if="selectVal" :size="20" color="#A2A3A4" name="clear" @click="handleRemoveVal" />
                <van-icon color="#A2A3A4" :size="20" name="arrow" @click="() => show = !show" />
            </div>
        </div>

        <!-- NOTE: 调用选择组件picker -->
        <van-popup v-model="show" position="bottom">
            <van-picker title="" show-toolbar :columns="columns" :value-key="pickerValueKey" @confirm="onConfirm"
                @cancel="onCancel" :default-index="defaultIndex" />
        </van-popup>
    </layout>
</template>

<style lang="less" scoped>
.custom-select {
    &-container {
        justify-content: space-between;

        .left {
            flex: 1;

            .value {
                font-size: 14px;
                font-weight: 400;
                color: #1A1A1F;
                line-height: 20px;
            }

            .default {
                font-size: 14px;
                font-weight: 400;
                color: #727273;
                line-height: 20px;
            }
        }

        .right {
            .van-icon {
                margin-left: 2px;
            }
        }
    }
}
</style>

<script>
import Layout from './Layout.vue';
export default {
    name: 'CSelect',
    components: {
        Layout
    },

    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        list: {
            type: Array,
            default: () => ([])
        },
        pickerValueKey: {
            type: [String, Number],
            default: ''
        },
        pickerValueId: {
            type: [String, Number],
            default: ''
        }
    },

    computed: {
        // picker defaul value
        defaultIndex() {
            let val = this.value
            if (!val) return 0
            let idx = this.list.findIndex(item => item[this.pickerValueId] == val)
            if (idx >= 0) return idx
            return 0
        },
    },

    data() {
        return {
            show: false,
            selectVal: '',
            columns: [],
        }
    },
    methods: {
        handleRemoveVal() {
            this.selectVal = ''
            this.$emit('input', '')
        },
        onConfirm(value) {
            this.selectVal = value[this.pickerValueKey]
            this.show = false
            console.log('???', value[this.pickerValueKey], value);
            this.$emit('input', value[this.pickerValueId])
        },
        onCancel() {
            this.show = false
            this.$listeners['cancel'] && this.$emit('cancel')
        },
    },
    watch: {
        list: {
            handler(arrs) {
                if (Array.isArray(arrs) && arrs.length) this.columns = arrs
            },
            immediate: true
        },
        value: {
            handler(val) {
                if (val) {
                    let arrs = this.list
                    if (Array.isArray(arrs) && arrs.length) {
                        let fidx = this.list.findIndex(item => item[this.pickerValueId] == val)
                        if (fidx >= 0) this.selectVal = this.list[fidx][this.pickerValueKey]
                    }
                }
            },
            immediate: true
        }
    }
}
</script>